import React from "react";
import "./refund-requests-pagination.scss";

interface RefundRequestsPaginationProps {
  hasNext: boolean;
  hasPrev: boolean;
  onNext: () => void;
  onPrev: () => void;
}

export const RefundRequestsPagination: React.FC<RefundRequestsPaginationProps> = ({
  hasNext,
  hasPrev,
  onNext,
  onPrev,
}) => {
  return (
    <div className="c-refund-requests-pagination">
      <div className="c-refund-requests-pagination__prev">
        {hasPrev && (
          <a href="#" onClick={onPrev}>
            &larr; Previous
          </a>
        )}
      </div>

      <div className="c-refund-requests-pagination__next">
        {hasNext && (
          <a href="#" onClick={onNext}>
            Next &rarr;
          </a>
        )}
      </div>
    </div>
  );
};
